import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { $switchCaseStrict } from 'dolla-switch';
import { LoadingWrapper } from '@prezi/common-components';
import { selectDocumentOid, selectViewlinks } from '../../../store';
import { viewLinkActions } from '../../../store/actions/viewLinkActions';
import { CreateLink, LinkSettings, LinksOverview } from './components';
import { getGlassboxLogger } from '../../../glassboxLogger';
var Screen = function (Screen) {
  Screen["LIST"] = "list";
  Screen["SETTINGS"] = "settings";
  Screen["CREATE"] = "create";
  return Screen;
}(Screen || {});
const ViewLinksPage = ({
  onBack
}) => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(viewLinkActions.getViewlinks());
  }, []);
  const isLoading = useSelector(selectViewlinks).loading;
  const documentOid = useSelector(selectDocumentOid);
  const [currentScreen, setCurrentScreen] = React.useState(Screen.LIST);
  const setCurrentScreenWithLogging = screen => {
    if (screen === Screen.CREATE) {
      getGlassboxLogger().logOpenCreateViewLinkDialog({
        prezi_oid: documentOid
      });
    }
    setCurrentScreen(screen);
  };
  const setViewToList = () => setCurrentScreenWithLogging(Screen.LIST);
  const [currentViewLinkId, setCurrentViewLinkId] = React.useState('');
  return React.createElement(LoadingWrapper, {
    isLoading: isLoading
  }, $switchCaseStrict(currentScreen, {
    [Screen.LIST]: () => React.createElement(LinksOverview, {
      onBack: onBack,
      onEdit: linkId => {
        setCurrentScreenWithLogging(Screen.SETTINGS);
        setCurrentViewLinkId(linkId);
      },
      onCreateNewLink: () => setCurrentScreenWithLogging(Screen.CREATE),
      onBackToListView: setViewToList
    }),
    [Screen.SETTINGS]: () => React.createElement(LinkSettings, {
      goBack: setViewToList,
      linkId: currentViewLinkId
    }),
    [Screen.CREATE]: () => React.createElement(CreateLink, {
      goBack: setViewToList
    })
  }));
};
export default ViewLinksPage;